//@ts-nocheck
import 'react-phone-number-input/style.css';
import {
  FC,
  FormEvent,
  useEffect,
  useMemo,
  useRef,
  useState,
  KeyboardEvent,
  ForwardedRef
} from 'react';
import cx from 'classnames';
import { Control, Controller, RefCallBack } from 'react-hook-form';
import flags from 'react-phone-number-input/flags';
import 'react-phone-number-input/style.css';
import {
  getCountryCallingCode,
  isValidPhoneNumber,
  parsePhoneNumber
} from 'react-phone-number-input/input-max';
const PhoneInput = dynamic(
  () => import('react-phone-number-input/input')
);
import RenderIfVisible from 'react-render-if-visible';
import Dropdown from 'components/Dropdown/Dropdown';
import UnionCaret from 'components/Icons/UnionCaret';
import countryList from 'data/country-names-by-code.data';
import useUpdateEffect from 'hooks/useUpdateEffect';
import { findVisitorCountryFromIP } from 'utils/common.utils';
import { forwardRef } from 'react';
import dynamic from 'next/dynamic';
import ContactUsCaret from 'components/Icons/ContactUsCaret';
import validate from 'pages/api/validate';
import intCountryList from 'data/int-country-names-by-code.data';
import { useRouter } from 'next/router';
let visitorCountry = '';

interface PhoneNumberInputProps {
  value: string;
  // eslint-disable-next-line no-unused-vars
  onChange: (value: any) => void;
  muted?: boolean;
  onBlur?: () => void;
  onFocus?: () => void;
  ref: ForwardedRef<RefCallBack>;
}

const countryPlaceholders: Record<string, string> = {
};

// eslint-disable-next-line react/display-name
const PhoneNumberInput: FC<PhoneNumberInputProps> = forwardRef(({
  value,
  onChange,
  onBlur,
  onFocus,
  muted
}, ref) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [countryCode, setCountryCode] = useState<string>('');
  const [tempValue, setTempValue] = useState('');
  const [isReady, setIsReady] = useState(false);

  const setInitialValue = async () => {
    if (value) {
      setTempValue(value);
    }

    if (value && isValidPhoneNumber(value)) {
      const result = parsePhoneNumber(value);
      if (!result?.country) {
        setTempValue('');
        setInitialValue();
        return;
      }
      setCountryCode(result?.country);
      return;
    }

    if (!visitorCountry) {
      visitorCountry = await findVisitorCountryFromIP();
    }

    setCountryCode(visitorCountry);
    if (value) phoneNumberUpdatedHandler('');
  };

  useEffect(() => {
    if (!wrapperRef.current) return;
    setInitialValue();

    setIsReady(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const phoneInputPlaceholder = useMemo(() => {
    return countryPlaceholders[countryCode] || '';
  }, [countryCode]);

  const countrySelectHandler = (selectedCountryCode: string) => {
    if (selectedCountryCode === countryCode) return;

    phoneNumberUpdatedHandler('');
    setCountryCode(selectedCountryCode);

    setTimeout(() => {
      const inputEl = document.querySelector(
        '[data-dresden-phone-input-wrapper] input'
      ) as HTMLInputElement;

      if (!inputEl) return;

      inputEl.focus();
    }, 500);
  };

  const phoneNumberUpdatedHandler = (newPhoneNumber: string) => {
    setTempValue(newPhoneNumber);
  };

  useUpdateEffect(() => {
    if (value !== tempValue && tempValue !== '' && typeof tempValue === 'string') {
      onChange(tempValue);
    }
  }, [tempValue]);

  return (
    <>
      <div
        ref={wrapperRef}
        className="grid grid-cols-[auto,1fr] gap-[10px]"
        data-dresden-phone-input>
        <CountrySelect
          onCountrySelect={countrySelectHandler}
          value={countryCode}
          muted={!!muted}
        />
        <div
          className={cx('h-[46px] flex w-full flex-col rounded p-2', {
            'bg-brand-grey125': muted,
            'border border-brand-grey175 bg-white': !muted
          })}>
          <div
            className="mt-[3px] text-[14px] "
            data-dresden-phone-input-wrapper>
            {isReady && (
              <PhoneInput
                value={tempValue}
                autoComplete="tel-national"
                country={countryCode as any}
                onChange={phoneNumberUpdatedHandler}
                withCountryCallingCode={false}
                international={true}
                placeholder={phoneInputPlaceholder}
                onBlur={() => {
                  onBlur?.();
                }}
                onFocus={() => onFocus?.()}
                maxLength={16}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
});

const CountrySelect: FC<{
  onCountrySelect: CountrySelectHandler;
  value: string;
  muted: boolean;
}> = ({ onCountrySelect, value, muted }) => {
  return (
    <Dropdown
      title="Select a Country"
      content={<CountrySelectOptions onCountrySelect={onCountrySelect} />}
      contentWrapperClassName="border !pl-[14px] !pr-[8px] !py-[12px] mt-[6px] shadow-dropdown"
      className={cx('z-[11] flex w-full min-w-[95px] flex-col rounded p-3 border border-brand-grey175 bg-white')}
      contentWrapperParentClassName="max-h-[160px] w-[260px]"
      wrapperClassName="flex flex-col">
      <div className="mt-[6px] flex cursor-pointer items-center justify-end h-[10px]">
        {value && (
          <span className="flex items-center text-brand-black100 ">
            <span className="mr-[6px] w-[26px] overflow-hidden rounded-[2px]">
              <CountryFlag countryCode={value} />
            </span>
            <span className="mb-[2px] text-[14px] leading-[16px]">
              +{getCountryCallingCode(value as any)}
            </span>
          </span>
        )}
        <span className="ml-[6px] mb-[1px] flex flex-auto justify-end">
          <ContactUsCaret />
        </span>
      </div>
    </Dropdown>
  );
};


const CountryFlag = ({ countryCode }: { countryCode: any }) => {
  const flagList = flags as Record<string, JSX.Element>;
  const flag = flagList[countryCode];
  // @ts-ignore
  return flag({ title: countryCode });
};

// eslint-disable-next-line no-unused-vars
type CountrySelectHandler = (countryCode: string) => void;

const CountrySelectOptions: FC<{
  onCountrySelect: CountrySelectHandler;
  onToggle?: () => void;
  isMobile?: boolean;
}> = ({ onCountrySelect, onToggle, isMobile }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [searchQuery, setSearchQuery] = useState('');
  const router = useRouter();
  const countries = useMemo(() => {
    let realCountryList = countryList;
    if (router.locale == 'international') {
      realCountryList = intCountryList;
    }

    if (!searchQuery) return realCountryList;
    const lowerCaseQuery = searchQuery.toLowerCase();

    return countryList.filter(
      (country) =>
        country.code.toLowerCase().includes(lowerCaseQuery) ||
        country.name.toLowerCase().includes(lowerCaseQuery)
    );
  }, [searchQuery]);

  useEffect(() => {
    if (isMobile || !inputRef?.current) return;

    inputRef.current?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchInputChangeHandler = (event: FormEvent<HTMLInputElement>) => {
    const target = event.target as HTMLInputElement;
    setSearchQuery(target.value);
  };

  const searchInputKeyDownHandler = (
    event: KeyboardEvent<HTMLInputElement>
  ) => {
    if (event.key !== 'Enter') return;

    event.preventDefault();

    const [firstOption] = countries || [];
    if (!firstOption) {
      setSearchQuery('');
      setTimeout(() => {
        inputRef.current?.focus?.();
      }, 100);
      return;
    }
    countrySelectHandler(firstOption.code);
  };

  const countrySelectHandler = (countryCode: string) => {
    onCountrySelect(countryCode);
    onToggle?.();
  };

  return (
    <div
      className={cx('relative pr-[8px]', {
        'pb-[70px]': isMobile
      })}>
      <div
        className={cx({
          'fixed bottom-0 left-0 w-full bg-brand-grey500 px-[16px] py-[16px]':
            isMobile,
          'sticky top-0 left-0 bg-white pb-[12px]': !isMobile
        })}>
        <input
          className="outline-none h-[36px] w-full rounded-[3px] border border-brand-grey400 bg-white px-[6px] align-middle text-[12px] lg:h-[30px]"
          placeholder="Search country"
          value={searchQuery}
          onInput={searchInputChangeHandler}
          ref={inputRef}
          onKeyDown={searchInputKeyDownHandler}
          onClick={(e) => e.stopPropagation()}
        />
      </div>
      <div className="flex flex-col" data-test>
        {countries.map((country) => (
          <span
            onClick={() => countrySelectHandler(country.code)}
            key={country.code}
            className="group mb-[12px] flex cursor-pointer items-center text-[14px] text-brand-black100 transition-colors last:mb-0 md:mb-[6px] lg:hover:text-brand-orange">
            <div className="mr-[6px] w-[32px] flex-shrink-0 overflow-hidden rounded-[2px] md:w-[24px]">
              <RenderIfVisible defaultHeight={16}>
                <CountryFlag countryCode={country.code} />
              </RenderIfVisible>
            </div>
            <span className="text-overflow mr-[6px] flex-auto overflow-hidden overflow-ellipsis whitespace-nowrap md:text-[13px]">
              {country.name}
            </span>
            <span className="flex-shrink-0 text-brand-grey300 transition-colors md:text-[13px] lg:group-hover:text-brand-orange">
              +{getCountryCallingCode(country.code as any)}
            </span>
          </span>
        ))}
      </div>
      {searchQuery && !countries.length && (
        <span className="inline-block text-center text-[12px] font-medium leading-[12px] text-brand-grey300 md:pt-[6px]">
          No countries were found matching your search.
        </span>
      )}
    </div>
  );
};

export const PhoneNumberInputController: FC<{
  control: Control<any>;
  required: boolean;
  name: string;
  defaultValue?: string;
  muted?: boolean;
}> = ({ control, required, name, muted, defaultValue = '' }) => {
  control;
  const isPhoneEmpty = control._formValues.phone === '';
  let rules = {
    required: false,
    validate: true
  };

  if (!isPhoneEmpty && typeof control._formValues.phone === 'string') {
    rules = {
      ...rules,
      validate: isValidPhoneNumber
    };
  }
  return (
    !!control && (
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field }) => <PhoneNumberInput muted={!!muted} {...field} ref={field.ref} />}
      />
    )
  );
};

export default PhoneNumberInputController;
